const DROPDOWN_TYPES = {
  menu: 'menu',
  profile: 'profile'
}

export {DROPDOWN_TYPES}